import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {
    Box,
    Grid,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardMedia,
    Button,
    Typography
} from '@material-ui/core'
// import Navbar from './Navbar';
import health from '../images/undraw_medicine_b1ol_(2).svg';
import church from '../images/undraw_compose_music_ovo2.svg';
import school from '../images/undraw_back_to_school_inwc_(1).svg';
import commerce from '../images/undraw_add_to_cart_vkjp_(1).svg';
import shop from '../images/undraw_shopping_app_flsj_(1).svg';
import twb from '../images/twb.jpg';
import quizrush from '../images/quizrush2.png';

const useStyles = makeStyles(theme =>({
    mainContainer: {
        background: "#233",
        height: "100%",
        marginTop: "50px",
    },
    cardContainer: {
        maxWidth: 345,
        margin: "5rem auto",
        [theme.breakpoints.down("sm")]:{
            maxWidth: "80%"
        }
    }
}))

const Portfolio = () => {
    const classes = useStyles()
    return (
        <Box component="div" className={classes.mainContainer}>
            {/* <Navbar/> */}
            <Grid container justify="center">
                {/* project1 */}
                <Grid item xs={12} sm={8} md={6}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                alt="Project 1"
                                height="150"
                                image={health}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    Haven Healthcare
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    A healthcare website. It houses modern design patterns and highly scalable. Has a gallery portfolio for firm's stock images, contact page and many other.
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary">
                                    Share
                                </Button>
                                <Button size="small" color="primary" href="https://emmanuel-darko.github.io/haven-care" target="_blank">
                                    Live Demo
                                </Button>
                            </CardActions>
                        </CardActionArea>
                    </Card>
                </Grid>

                {/* project2 */}
                <Grid item xs={12} sm={8} md={6}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                alt="Project 2"
                                height="150"
                                image={church}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    Church Management
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    Church Management System. This application has many features such as attendance tracking, member information database, announcement section and many other.
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary">
                                    Share
                                </Button>
                                <Button size="small" color="primary" href="https://english-attendance.herokuapp.com" target="_blank">
                                    Live Demo
                                </Button>
                            </CardActions>
                        </CardActionArea>
                    </Card>
                </Grid>

                {/* project3 */}
                <Grid item xs={12} sm={8} md={6}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                alt="Project 3"
                                height="150"
                                image={school}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    School Management
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    School Management System. This application has a number of modern features such as cloud-based management, academic management, accounts management, attendance tracking, live classes, bookstore and 1 website. 
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary">
                                    Share
                                </Button>
                                <Button size="small" color="primary" href="http://school-ms.great-site.net" target="_blank">
                                    Live Demo
                                </Button>
                            </CardActions>
                        </CardActionArea>
                    </Card>
                </Grid>

                {/* project4 */}
                <Grid item xs={12} sm={8} md={6}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                alt="Project 4"
                                height="150"
                                image={commerce}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    E-commerce
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    E-commerce app for electronics. Comes with cart functionalities, checkout functionalities, invoice note and many other.
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary">
                                    Share
                                </Button>
                                <Button size="small" color="primary" href="https://henkoqonline.com" target="_blank">
                                    Live Demo
                                </Button>
                            </CardActions>
                        </CardActionArea>
                    </Card>
                </Grid>

                {/* project5 */}
                <Grid item xs={12} sm={8} md={6}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                alt="Project 5"
                                height="150"
                                image={shop}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    Shopping List
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    Get a list of all items to be purchased, grocery list, personal to-dos etc. This application gives you the functionality to add, edit and remove items. Also provides password protection.    
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary">
                                    Share
                                </Button>
                                <Button size="small" color="primary" href="https://kode-mern-cart.herokuapp.com/" target="_blank">
                                    Live Demo
                                </Button>
                            </CardActions>
                        </CardActionArea>
                    </Card>
                </Grid>

                {/* project6 */}
                <Grid item xs={12} sm={8} md={6}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                alt="Project 5"
                                height="150"
                                image={twb}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    The Writers Blog & Book Club
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                <u> Site Management & Development</u><br></br>
                                    A home for writers and Book Club for kids.
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary">
                                    Share
                                </Button>
                                <Button size="small" color="primary" href="https://bookclub.thewritersbloggh.com/" target="_blank">
                                    Visit
                                </Button>
                            </CardActions>
                        </CardActionArea>
                    </Card>
                </Grid>

                {/* project7 */}
                <Grid item xs={12} sm={8} md={6}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                alt="Project 5"
                                height="150"
                                image={"https://gdurl.com/C69k"}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    Reveal Multimedia Gh
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    <u> Site Management </u><br></br>
                                    Reveal Multimedia is a creative outfit that helps its clients bring every creative idea to life.
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary">
                                    Share
                                </Button>
                                <Button size="small" color="primary" href="https://revealmultimediagh.org" target="_blank">
                                    Visit
                                </Button>
                            </CardActions>
                        </CardActionArea>
                    </Card>
                </Grid>
                {/* project8 */}
                <Grid item xs={12} sm={8} md={6}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                
                                alt="Project 5"
                                height="150"
                                image={"https://oncloudbutamen.netlify.app/img/k-logo-sm-1.png"}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    #Oncloudbutamen
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    <u> Wedding Website for Karen and Joshua </u><br></br>
                                    A website that give pre-wedding information with regards to Dress code, contacts and location
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary">
                                    Share
                                </Button>
                                <Button size="small" color="primary" href="https://oncloudbutamen.netlify.app/" target="_blank">
                                    Visit
                                </Button>
                            </CardActions>
                        </CardActionArea>
                    </Card>
                </Grid>

                {/* project9 */}
                <Grid item xs={12} sm={8} md={6}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                alt="Project 5"
                                height="150"
                                image={"https://gdurl.com/J1_P"}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    Quizrush Mobile App
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    <u> App under Development </u><br></br>
                                    A Quiz game on various categories. Play and win some cash.
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary">
                                    Download
                                </Button>
                                <Button size="small" color="primary" href="https://drive.google.com/file/d/1DOdbHt61abD1JDD_Qs_J06Mu4DHY6Fct/view?usp=share_link" target="_blank">
                                    Demo
                                </Button>
                            </CardActions>
                        </CardActionArea>
                    </Card>
                </Grid>

                {/* project9 */}
                <Grid item xs={12} sm={8} md={6}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                alt="Project 5"
                                height="150"
                                image={"https://gdurl.com/FbR1"}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    Clappnet ISP App
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    <u> App under Developement </u><br></br>
                                    A decentralized Internet Service Provider
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary">
                                    Download
                                </Button>
                                <Button size="small" color="primary" href="https://drive.google.com/file/d/14pp6geRY6bAdaBmWVq5Vqs_0EV4Q79a4/view?usp=share_link" target="_blank">
                                    Demo
                                </Button>
                            </CardActions>
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Portfolio
